module.exports = __webpack_public_path__ + "img/notification-icons.e118f190.svg";